export enum MessageType {
    Status = 1,
    Chat = 2,
    Automated = 3,
}

export default MessageType;
